import React, {useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {bbFindUserTagsByTagId} from "../../../util/bbHelpers";
import {Tooltip} from "@material-ui/core";
import ComingSoonIconSettings from "./ComingSoonIconSettings";
import {
    disableBRLabs,
    disableEmailNotifications,
    enableBRLabs,
    enableEmailNotifications,
    updateEmailFrequencyTag
} from "../../../actions";

const EmailOptInRadio = ({customer=null}) => {

    const authUser = useSelector(({auth}) => auth.authUser);
    // const {loadingAddTag, loadingAddTagError, loadingUpdateTag, loadingUpdateTagError} = useSelector(({breachrisk})=> breachrisk);
    const dispatch = useDispatch();
    const isDisabled = true;
    const textColor = isDisabled && "text-light-gray";

    const emailOptInTags = bbFindUserTagsByTagId(authUser, 14);
    const hasTags = emailOptInTags && emailOptInTags.length > 0;

    const [optIn, setOptIn] = useState(hasTags);

    const handleSelect = (value) => {
        setOptIn(value)

        const emailFrequencyTags = bbFindUserTagsByTagId(authUser, 56)

        // const findEmailFrequency = hasTags && emailFrequencyTags && emailFrequencyTags.lenght > 0
        //     ? emailFrequencyTagsp[0].details

        if(!hasTags && value === true){
            dispatch(enableEmailNotifications(authUser.user.id))
        } else if (hasTags && value === false){
            dispatch(disableEmailNotifications(emailOptInTags[0]))

            if(emailFrequencyTags && emailFrequencyTags.length > 0){
                dispatch(updateEmailFrequencyTag(emailFrequencyTags[0]))
            }
        }
    }

    return(
            <div className={`row ${textColor}`}>
                <Tooltip title={"Select whether or not you would like to receive email notifications."}>
                    <>
                        <p className={"col-5 text-right align-self-center"}>Receive Email Notifications:</p>
                        <p className={"col-1"}> </p>
                        <div className={"col-5 text-left"}>
                            <form className={"m-0 p-0 d-inline"}>
                                <div className={"col-6 d-inline m-0 p-0"}>
                                    <input type="radio"
                                           id="getEmails"
                                           name={"true"}
                                           value={true}
                                           disabled={isDisabled}
                                           checked={optIn === true}
                                           onChange={(e)=>handleSelect(true)}
                                    />
                                    <label htmlFor="getEmails">&nbsp; Yes</label>
                                </div>
                                <div className={"col-6 d-inline"}>
                                    <input type="radio"
                                           id="noEmails"
                                           name={"false"}
                                           value={true}
                                           disabled={isDisabled}
                                           checked={optIn === false}
                                           onChange={(e)=>handleSelect(false)}
                                    />
                                    <label htmlFor="noEmails">&nbsp; No</label>
                                </div>
                            </form>
                        </div>
                    </>
                </Tooltip>
                { isDisabled && <ComingSoonIconSettings className={`mb-1 pb-2 ${textColor}`}/>}
            </div>
    )
}

export default EmailOptInRadio;